import React, { useState } from "react";
import { Card, Grid, Image } from "semantic-ui-react";
import useTheme from "../../../../hooks/useTheme";
import { useSelector } from "react-redux";
import { generateLandingSearchUrl, getLocale } from "../../../../utils/helperFunctions";
import { SizedBox } from "../../../UI/Sizes";
import AppText from "../../../UI/Texts/AppTexts";
import { useResponsive } from "../../../UI/ResponsiveContext";

const AvailableWorkfields = ({ availableJobs }) => {
    const theme = useTheme();
    const { isMobile, isTablet, size } = useResponsive();

    const core = useSelector((state) => state?.core);
    const constants = core?.constants;

    const appWorkfields = constants?.workfields;

    const { workfields, queryData } = availableJobs;

    if (workfields.length === 0) {
        return (<div></div>)
    }

    return (
        <Grid stackable columns={(() => {
            if (isMobile) {
                return 2;
            } else if (isTablet) {
                return 3;
            } else if (size.width > 1400) {
                return 5;
            } else {
                return 4;
            }

        })()} style={{
            marginTop: !isMobile && theme.spacing.elementPadding,
            marginBottom: !isMobile && theme.spacing.contentElementPadding,
        }}>
            {workfields.map((workfield) => {
                const workfieldData = appWorkfields?.find((e) => e.id === workfield);
                const text = workfieldData?.text[getLocale()];

                const altText = `${text}-ikon - symboliserar ${text?.toLowerCase()} och relaterade vårdtjänster via Staffi`

                return (<Grid.Column floated >
                    <WorkfieldCard
                        key={workfield}
                        workfieldData={workfieldData}
                        text={text}
                        altText={altText}
                        queryData={queryData}
                    />
                </Grid.Column>)
            })}

        </Grid>
    );
}




export default AvailableWorkfields;


const WorkfieldCard = ({ workfieldData, text, altText, queryData }) => {
    const theme = useTheme();

    const { isMobile } = useResponsive();
    const [isHovered, setIsHovered] = useState(false);

    const core = useSelector((state) => state?.core);
    const constants = core?.constants;


    const iconPath = "/assets/workfields";


    const handleMouseEnter = () => {
        if (isMobile) return;
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        if (isMobile) return;

        setIsHovered(false);
    };


    return (<Card
        href={`/${generateLandingSearchUrl({
            constants: constants,
            workfields: workfieldData ? [workfieldData?.id] : [],
            locations: queryData.location ? [queryData.location.key] : [],
            workroles: queryData.role ? [queryData.role.roleId]: [],
        })}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        target="_blank"
        style={{
            padding: theme.spacing.elementPadding,
            borderRadius: theme.radius.default,
            cursor: 'pointer',
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
            border: "1px solid rgba(0, 0, 0, 0.1)",
            width: '100%',
        }}>
        <Image
            src={`${iconPath}/${workfieldData?.iconId}`}
            alt={altText}
            loading="lazy"
            height={30}
            width={30}
            style={{
                height: "30px",
                width: "30px",
                opacity: "0.8",
                mixBlendMode: "multiply",
                marginBottom: theme.spacing.elementPaddingSmall,
                display: "block",
                filter: "grayscale(1)",
            }}
        />
        <SizedBox height={theme.spacing.elementPaddingSmall} />
        <AppText.BodyText
            use={'h2'}
            margins={{
                marginTop: '0px',
                marginBottom: '0px',
            }}
            style={{
                whiteSpace: !isHovered && "nowrap",
                overflow: "hidden",
                width: isMobile ? "250px" : "200px",
                textOverflow: "ellipsis",
                cursor: "pointer",
                lineHeight: "1.5",
                WebkitLineClamp: isMobile ? 2 : 1,
                display: isMobile && "-webkit-box",
                WebkitBoxOrient: "vertical",
            }}
            fontWeight={600}>{text}</AppText.BodyText>

    </Card>)
}